import { __awaiter } from '../../_virtual/_tslib.js';
import { useContext } from 'react';
import { AppContext } from '../../app-context.js';
import { CUSTOM_EVENTS } from '../../constants/misc.js';
import { createCustomEvents } from '../../methods/createCustomEvents.js';
import { useUpdateCompanyDetails, handleUpdateCompanyDetails } from '../../_services/hooks/useUserProfileService.js';
import { AuthServiceAdminConsole } from '../../_services/auth.adminConsole.service.js';
import { AuthService } from '../../_services/auth.service.js';
import { getFBEventId, sendPageSenseEvent, ga4SetUser } from '../../_services/user-analytics.service.js';
import { toast } from '../toast/toast.js';
import { useSendOTP } from '../../_services/sms.service.js';
import { useSendWhatsappOTP } from '../../_services/whatsapp-otp.service.js';

function useAuth({ phoneNum, otp, name, serviceType, whatsappUpdatesEnabled, placeId, isInitiatedFrom, referralCode, otpScope, user_joining_bonus_enabled }) {
    const { setPhoneNum, setName, setCompanyId, isPhoneVerified, setIsPhoneVerified, setCompanyLocation, setCompanyLogo, setUserId, userId, setServiceType, lang, setLang, setCsDashboardUserRoles, isCsDashboardUser, sessionId, setSessionId } = useContext(AppContext);
    const { mutateAsync: updateCompanyDetails } = useUpdateCompanyDetails();
    const { mutate: sendOTP } = useSendOTP();
    const { mutate: sendWaOTP } = useSendWhatsappOTP();
    const onSubmitPhoneNum = (storePhoneNum = true) => __awaiter(this, void 0, void 0, function* () {
        if (!phoneNum) {
            // isPhoneVerified removed
            return;
        }
        !!storePhoneNum && (setPhoneNum === null || setPhoneNum === void 0 ? void 0 : setPhoneNum(phoneNum));
        sendOTP({ phoneNumber: phoneNum, scope: otpScope }, {
            onSuccess: (res) => {
                if (res && res.data && res.data.message) {
                    toast.success(res.data.message);
                }
                else {
                    toast.success("OTP sent successfully!");
                }
            },
            onError: (res) => {
                if (res && res.message) {
                    toast.error(res.message);
                }
                else {
                    toast.error("Error! Could not send the OTP.");
                }
            }
        });
    });
    const sendOtpViaWhatsapp = ({ onSuccessCallback, onSettledCallback }) => __awaiter(this, void 0, void 0, function* () {
        if (!phoneNum) {
            onSettledCallback === null || onSettledCallback === void 0 ? void 0 : onSettledCallback();
            return false;
        }
        sendWaOTP({ phoneNumber: phoneNum }, {
            onSuccess: (res) => {
                if (res && res.data && res.data.message) {
                    toast.success(res.data.message);
                }
                else {
                    toast.success("OTP sent successfully!");
                }
                onSuccessCallback();
                onSettledCallback === null || onSettledCallback === void 0 ? void 0 : onSettledCallback();
            },
            onError: (res) => {
                if (res && res.message) {
                    toast.error(res.message);
                }
                else {
                    toast.error("Error! Could not send the OTP.");
                }
                onSettledCallback === null || onSettledCallback === void 0 ? void 0 : onSettledCallback();
            }
        });
        return false;
    });
    const onClickResendOtp = ({ isWhatsApp = false, onSuccessCallback, onSettledCallback }) => __awaiter(this, void 0, void 0, function* () {
        if (!phoneNum) {
            onSettledCallback === null || onSettledCallback === void 0 ? void 0 : onSettledCallback();
            return false;
        }
        sendOTP({ phoneNumber: phoneNum, scope: otpScope, isWhatsApp }, {
            onSuccess: (res) => {
                if (res && res.data && res.data.message) {
                    toast.success(res.data.message);
                }
                else {
                    toast.success("OTP sent successfully!");
                }
                onSuccessCallback();
                onSettledCallback === null || onSettledCallback === void 0 ? void 0 : onSettledCallback();
            },
            onError: (res) => {
                if (res && res.message) {
                    toast.error(res.message);
                }
                else {
                    toast.error("Error! Could not send the OTP.");
                }
                onSettledCallback === null || onSettledCallback === void 0 ? void 0 : onSettledCallback();
            }
        });
        return false;
    });
    const addLoginOrRegisterSuccessfullEvent = () => {
        createCustomEvents({ eventName: CUSTOM_EVENTS.LOGGEDIN });
    };
    const onSubmitOtp = (override) => __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        const resolvedPhoneNum = (_a = override === null || override === void 0 ? void 0 : override.phoneNum) !== null && _a !== void 0 ? _a : phoneNum;
        const resolvedOtp = (_b = override === null || override === void 0 ? void 0 : override.otp) !== null && _b !== void 0 ? _b : otp;
        if (!resolvedPhoneNum || !resolvedOtp) {
            return;
        }
        const { data } = yield AuthService.loginViaOtp({
            phone_number: resolvedPhoneNum,
            otp: resolvedOtp,
            is_wa_optin: whatsappUpdatesEnabled
        });
        setSessionId === null || setSessionId === void 0 ? void 0 : setSessionId(data === null || data === void 0 ? void 0 : data.session_id);
        // User model exists
        if (data) {
            if (isCsDashboardUser) {
                const userRoles = yield AuthServiceAdminConsole.getUserRoles(data.u_id);
                if (userRoles === null || userRoles === void 0 ? void 0 : userRoles.id) {
                    userRoles && (setCsDashboardUserRoles === null || setCsDashboardUserRoles === void 0 ? void 0 : setCsDashboardUserRoles(userRoles.roles));
                }
                else {
                    toast.error("No access, Please reach out to manager.");
                }
            }
            // login
            setIsPhoneVerified === null || setIsPhoneVerified === void 0 ? void 0 : setIsPhoneVerified(true);
            setName === null || setName === void 0 ? void 0 : setName(data.c_name);
            setCompanyId === null || setCompanyId === void 0 ? void 0 : setCompanyId(data.c_id);
            setCompanyLocation === null || setCompanyLocation === void 0 ? void 0 : setCompanyLocation(data.c_loc);
            setUserId === null || setUserId === void 0 ? void 0 : setUserId(data.u_id);
            if (lang) {
                handleUpdateCompanyDetails(updateCompanyDetails, {
                    companyId: data === null || data === void 0 ? void 0 : data.c_id,
                    languageCode: lang
                });
            }
            else {
                setLang === null || setLang === void 0 ? void 0 : setLang(data.lang);
            }
            setCompanyLogo === null || setCompanyLogo === void 0 ? void 0 : setCompanyLogo(data === null || data === void 0 ? void 0 : data.profile_image);
            if (data.c_serv)
                setServiceType === null || setServiceType === void 0 ? void 0 : setServiceType(data.c_serv);
            if (data.c_id) {
                const eventID = getFBEventId("login", data === null || data === void 0 ? void 0 : data.c_id);
                (_c = window.fbq) === null || _c === void 0 ? void 0 : _c.call(window, "track", "AddToCart", { phoneNum }, { eventID });
                // sendFbCapiEvent({ event_id: eventID, event_name: "AddToCart", phone_num: phoneNum });
                sendPageSenseEvent("Login Success");
            }
            else {
                // User Registration
                const eventID = getFBEventId("register", data === null || data === void 0 ? void 0 : data.u_id);
                (_d = window.fbq) === null || _d === void 0 ? void 0 : _d.call(window, "track", "AddToWishlist", { phoneNum }, { eventID });
                // sendFbCapiEvent({ event_id: eventID, event_name: "AddToWishlist", phone_num: phoneNum });
                sendPageSenseEvent("User Registration Succes");
            }
            ga4SetUser(data.u_id);
            addLoginOrRegisterSuccessfullEvent();
            return {
                status: true,
                companyName: data.c_name,
                companyId: data.c_id,
                serviceType: data.c_serv,
                userId: data.u_id,
                createdAt: data.user_created_at
            };
        }
    });
    const onSubmitCompanyDetails = (override) => __awaiter(this, void 0, void 0, function* () {
        var _e, _f, _g, _h, _j;
        const resolvedName = (_e = override === null || override === void 0 ? void 0 : override.name) !== null && _e !== void 0 ? _e : name;
        const resolvedUserId = (_f = override === null || override === void 0 ? void 0 : override.userId) !== null && _f !== void 0 ? _f : userId;
        const resolvedServiceType = (_g = override === null || override === void 0 ? void 0 : override.serviceType) !== null && _g !== void 0 ? _g : serviceType;
        const resolvedPlaceId = (_h = override === null || override === void 0 ? void 0 : override.placeId) !== null && _h !== void 0 ? _h : placeId;
        // company sign up
        if (!resolvedName || !resolvedUserId || !resolvedServiceType) {
            return;
        }
        setName === null || setName === void 0 ? void 0 : setName(resolvedName);
        const data = yield AuthService.registerCompanyDetails({
            userId: parseInt(String(resolvedUserId), 10),
            name: resolvedName,
            serviceType: resolvedServiceType,
            placeId: resolvedPlaceId || "",
            referralCode: referralCode,
            sessionId: sessionId,
            user_joining_bonus_enabled
        });
        if (!data) {
            toast.error("Something went wrong, Please try again later or contact customer support!");
            return { status: false, companyName: null, companyId: null };
        }
        /**
         * As this is the last step,
         * here is where we complete the signup process
         */
        setCompanyId === null || setCompanyId === void 0 ? void 0 : setCompanyId(data === null || data === void 0 ? void 0 : data.c_id);
        if (lang) {
            handleUpdateCompanyDetails(updateCompanyDetails, {
                companyId: data === null || data === void 0 ? void 0 : data.c_id,
                languageCode: lang
            });
        }
        setCompanyLogo === null || setCompanyLogo === void 0 ? void 0 : setCompanyLogo(data === null || data === void 0 ? void 0 : data.profile_image);
        setServiceType === null || setServiceType === void 0 ? void 0 : setServiceType(resolvedServiceType);
        const eventID = getFBEventId("signup", data === null || data === void 0 ? void 0 : data.c_id);
        (_j = window.fbq) === null || _j === void 0 ? void 0 : _j.call(window, "track", "CompleteRegistration", { phoneNum }, { eventID });
        // sendFbCapiEvent({ event_id: eventID, event_name: "CompleteRegistration", phone_num: phoneNum });
        sendPageSenseEvent("Signup Succes");
        return {
            status: true,
            companyName: data.c_name,
            companyId: data.c_id,
            userId: data.u_id,
            createdAt: data.user_created_at
        };
    });
    return {
        onSubmitPhoneNum,
        onClickResendOtp,
        onSubmitOtp,
        onSubmitCompanyDetails,
        sendOtpViaWhatsapp
    };
}

export { useAuth };
//# sourceMappingURL=useAuth.js.map
